import { useEffect, useState } from 'react';
import _ from 'lodash';

const getInitialState = (value, valueId) => {
  const newValue = _.cloneDeep(value);
  if (newValue.parentId) {
    newValue.value = valueId && newValue.value && newValue.value[valueId] ? newValue.value[valueId].value : null;
  }
  return newValue;
};

const Hook = props => {
  const [isInEdit, setIsInEdit] = useState(false);
  const [item, setItem] = useState(getInitialState(props.input.value, props.multipleChoiceId));

  useEffect(() => {
    // Для корректного обновления после переинициализации
    // if ((!props.meta.dirty && !props.meta.touched) || item.typeId === 9 || item.typeId === 3) {
    setItem(getInitialState(props.input.value, props.multipleChoiceId));
    // }
  }, [props.input.value, props.multipleChoiceId]);

  useEffect(() => {
    // Для сохранения состояние кнопки сохранить все и атрибута после переинициализации
    if (isInEdit && !props.default.anyTouched) {
      props.default.touch(props.input.name);
    }
  });

  useEffect(() => {
    // Убираем все режими сохранения после нажатия "Сохранить все"
    setIsInEdit(false);
  }, [props.meta.submitting]);

  useEffect(() => {
    // Выход из режима редактирвоания после нажатия кнопки "Отменить все"
    if (!props.meta.dirty && !props.meta.touched) {
      setIsInEdit(false);
    }
  }, [props.meta.dirty]);

  useEffect(() => {
    // Убираем режим редактирвония при закрытие окна с деталями
    setIsInEdit(props.isDetailsOpen);
  }, [props.isDetailsOpen]);

  const handleSave = () => {
    setIsInEdit(false);
    // Закрываем окно с детализацией при сохранении выпадающего списка или множественного выбора
    if (item.typeId === 9 || item.typeId === 4) {
      props.onClose();
    }
    // Для корректного сохранения одного атрибута
    props.default.change('field', props.input.value.id);
  };
  const handleChange = value => {
    setItem({ ...item, value });
    props.input.onChange({
      ...item,
      value: props.multipleChoiceId ? { ...props.input.value.value, [props.multipleChoiceId]: { value } } : value,
    });
  };
  const handleCancel = () => {
    setIsInEdit(false);
    setItem(props.meta.initial);
    // Сбрасываем только нужный элеменгт
    props.default.change(props.input.name, props.meta.initial);
    if (item.typeId === 9) {
      props.onClose();
      props.default.untouch(...(item.children || []).map((el, index) => `${props.input.name}.children[${index}]`));
    } else {
      props.default.untouch(props.input.name);
    }
  };

  const handleReset = e => {
    e.stopPropagation();
    const newItem = _.cloneDeep(item);
    delete newItem.value;
    setItem(newItem);
    props.input.onChange(newItem);
    props.default.change('field', props.input.value.id);
  };

  return {
    isInEdit,
    item,
    handleEdit: () => setIsInEdit(true),
    handleSave,
    handleReset,
    handleChange,
    handleCancel,
  };
};

export default Hook;
